import { getActiveRegion } from 'api-client/helpers'
interface BYOMachineTemplateParams {
  name: string
  namespace: string
  clusterName: string
  k8sInstallerConfigTemplateRefName: string
}
export const createBYOMachineTemplateBody = ({
  name,
  namespace,
  clusterName,
  k8sInstallerConfigTemplateRefName,
}: BYOMachineTemplateParams) => {
  return {
    apiVersion: 'infrastructure.cluster.x-k8s.io/v1beta1',
    kind: 'ByoMachineTemplate',
    metadata: {
      name,
      namespace,
      labels: {
        'pcd-kaapi.pf9.io/region': getActiveRegion(),
      },
    },
    spec: {
      template: {
        spec: {
          selector: {
            matchLabels: {
              'kaapi.pf9.io/cluster-name': clusterName,
            },
          },
          installerRef: {
            apiVersion: 'infrastructure.cluster.x-k8s.io/v1beta1',
            kind: 'K8sInstallerConfigTemplate',
            name: k8sInstallerConfigTemplateRefName,
            namespace,
          },
        },
      },
    },
  }
}
